// ReadOnlyRenderer.tsx

import { Box } from '@mui/material'
import { RichTextReadOnly } from 'mui-tiptap'
import React from 'react'
import useExtensions from './useExtensions' // <-- same hook you use for the editor

type Props = {
  content: string
  users?: any[] // pass if your mentions need user data
}
const EMPTY_USERS: any[] = []
const ReadOnlyRenderer: React.FC<Props> = ({ content, users }) => {
  // If your hook supports a readOnly flag, pass it; otherwise just reuse it as-is.
  const stableUsers = users ?? EMPTY_USERS
  const extensions = useExtensions({
    placeholder: '',
    users: stableUsers,
    // readOnly: true,
  } as any)

  // Tip: if `content` changes over time, RichTextReadOnly handles it for you.

  return (
    <Box
      sx={{
        '& img': {
          maxWidth: '100%',
          height: 'auto',
          display: 'block',
          borderRadius: 1,

          // ✅ reduce scroll jank / layout shift
          contentVisibility: 'auto', // only paint when near viewport (Chromium)
          containIntrinsicSize: '800px 450px', // placeholder size before image loads
        },

        '& table': { width: '100%', borderCollapse: 'collapse' },
        '& td, & th': { border: '1px solid', borderColor: 'divider', padding: 0.5 },
        '& a': { wordBreak: 'break-word' },
      }}
    >
      <RichTextReadOnly
        content={content || ''}
        extensions={extensions}
        editorProps={{
          attributes: {
            class: 'rte-readonly',
            style: 'outline:0; maxHeight: 20vh; height: auto;',
          },
        }}
      />
    </Box>
  )
}

export default React.memo(ReadOnlyRenderer)
